import React from 'react'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import { MotionCard, MotionIcon, MotionSection } from '../motion/Motion'

export default function FeaturesSection() {
  return (
    <MotionSection className="w-[96%] sm:w-[86%] md:w-[72%] lg:w-[60%] mx-auto py-10">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-[20px] lg:gap-[28px] items-start justify-items-center">
        <MotionCard className="flex flex-col items-center text-center" delay={0.02}>
          <div className="flex items-center justify-center h-[56px] w-[56px] rounded-full bg-gray-200">
            <div className="flex items-center justify-center h-[44px] w-[44px] rounded-full bg-pink-500">
              <MotionIcon>
                <LocalShippingOutlinedIcon className="text-white" fontSize="small" />
              </MotionIcon>
            </div>
          </div>
          <h3 className="mt-4 text-[14px] font-bold uppercase tracking-wide text-gray-900">
            FREE AND FAST DELIVERY
          </h3>
          <p className="mt-1 text-[13px] text-gray-600">
            Fast door-to-door delivery across Gauteng
          </p>
        </MotionCard>

        <MotionCard className="flex flex-col items-center text-center" delay={0.07}>
          <div className="flex items-center justify-center h-[56px] w-[56px] rounded-full bg-gray-200">
            <div className="flex items-center justify-center h-[44px] w-[44px] rounded-full bg-pink-500">
              <MotionIcon>
                <SupportAgentOutlinedIcon className="text-white" fontSize="small" />
              </MotionIcon>
            </div>
          </div>
          <h3 className="mt-4 text-[14px] font-bold uppercase tracking-wide text-gray-900">
            24/7 CUSTOMER SERVICE
          </h3>
          <p className="mt-1 text-[13px] text-gray-600">
            Friendly 24/7 customer support
          </p>
        </MotionCard>

        <MotionCard className="flex flex-col items-center text-center" delay={0.12}>
          <div className="flex items-center justify-center h-[56px] w-[56px] rounded-full bg-gray-200">
            <div className="flex items-center justify-center h-[44px] w-[44px] rounded-full bg-pink-500">
              <MotionIcon>
                <GppGoodOutlinedIcon className="text-white" fontSize="small" />
              </MotionIcon>
            </div>
          </div>
          <h3 className="mt-4 text-[14px] font-bold uppercase tracking-wide text-gray-900">
            MONEY BACK GUARANTEE
          </h3>
          <p className="mt-1 text-[13px] text-gray-600">
            We return money within 30 days
          </p>
        </MotionCard>
      </div>
    </MotionSection>
  )
}
